<div class="container">
    <span class="title">{{title}}</span>
    <span class="text" [innerHTML]="body"></span>
    <div class="inputs">
        <input
            #textInput
            placeholder="{{placeholder}}"
            [pattern]="getPattern()"
            spellcheck="false"
            [(ngModel)]="input"
            [maxlength]="maxlength"
            (ionInput)="onUpdate($event)"
            [type]="inputType"
            [autocomplete]="inputType === 'text' ? 'off' : 'one-time-code'"
        >
    </div>
    <div class="buttons">
        <span 
            *ngIf="cancelText"
            class="cancel clickable ion-activatable" 
            (click)="cancel()"
        >
            {{cancelText.toLowerCase()}}
            <ion-ripple-effect></ion-ripple-effect>
        </span>
        <span
            class="submit clickable ion-activatable"
            (click)="confirm()"
        >
            {{okText.toLowerCase()}}
            <ion-ripple-effect></ion-ripple-effect>
        </span>
    </div>
</div>